/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OfflineControlRouteImport } from './routes/offline-control'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AccountDeletionRouteImport } from './routes/account-deletion'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FollowTokenRouteImport } from './routes/follow.$token'
import { Route as AuthenticatedUploadModeRouteImport } from './routes/_authenticated.upload-mode'
import { Route as AuthenticatedUploadRouteImport } from './routes/_authenticated.upload'
import { Route as AuthenticatedTripRouteImport } from './routes/_authenticated.trip'
import { Route as AuthenticatedTrackingRouteImport } from './routes/_authenticated.tracking'
import { Route as AuthenticatedQueueRouteImport } from './routes/_authenticated.queue'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated.profile'
import { Route as AuthenticatedPermissionsRouteImport } from './routes/_authenticated.permissions'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated.notifications'
import { Route as AuthenticatedMyUploadsRouteImport } from './routes/_authenticated.my-uploads'
import { Route as AuthenticatedLibraryRouteImport } from './routes/_authenticated.library'
import { Route as AuthenticatedJoinRouteImport } from './routes/_authenticated.join'
import { Route as AuthenticatedItineraryRouteImport } from './routes/_authenticated.itinerary'
import { Route as AuthenticatedInboxRouteImport } from './routes/_authenticated.inbox'
import { Route as AuthenticatedFaceIdIntroRouteImport } from './routes/_authenticated.face-id-intro'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated.admin'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated.admin.index'
import { Route as AuthenticatedSettingsPrivacyRouteImport } from './routes/_authenticated.settings.privacy'
import { Route as AuthenticatedAdminNotificationsRouteImport } from './routes/_authenticated.admin.notifications'
import { Route as AuthenticatedAdminMapRouteImport } from './routes/_authenticated.admin.map'
import { Route as AuthenticatedAdminLibraryRouteImport } from './routes/_authenticated.admin.library'
import { Route as AuthenticatedAdminInvitesRouteImport } from './routes/_authenticated.admin.invites'
import { Route as AuthenticatedAdminFamilyRouteImport } from './routes/_authenticated.admin.family'
import { Route as AuthenticatedAdminExportRouteImport } from './routes/_authenticated.admin.export'
import { Route as AuthenticatedAdminAiRouteImport } from './routes/_authenticated.admin.ai'
import { Route as AuthenticatedAdminTravelersUserIdRouteImport } from './routes/_authenticated.admin.travelers.$userId'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OfflineControlRoute = OfflineControlRouteImport.update({
  id: '/offline-control',
  path: '/offline-control',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDeletionRoute = AccountDeletionRouteImport.update({
  id: '/account-deletion',
  path: '/account-deletion',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FollowTokenRoute = FollowTokenRouteImport.update({
  id: '/follow/$token',
  path: '/follow/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUploadModeRoute = AuthenticatedUploadModeRouteImport.update({
  id: '/upload-mode',
  path: '/upload-mode',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUploadRoute = AuthenticatedUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTripRoute = AuthenticatedTripRouteImport.update({
  id: '/trip',
  path: '/trip',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTrackingRoute = AuthenticatedTrackingRouteImport.update({
  id: '/tracking',
  path: '/tracking',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedQueueRoute = AuthenticatedQueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPermissionsRoute =
  AuthenticatedPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyUploadsRoute = AuthenticatedMyUploadsRouteImport.update({
  id: '/my-uploads',
  path: '/my-uploads',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLibraryRoute = AuthenticatedLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJoinRoute = AuthenticatedJoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedItineraryRoute = AuthenticatedItineraryRouteImport.update({
  id: '/itinerary',
  path: '/itinerary',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInboxRoute = AuthenticatedInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFaceIdIntroRoute =
  AuthenticatedFaceIdIntroRouteImport.update({
    id: '/face-id-intro',
    path: '/face-id-intro',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedSettingsPrivacyRoute =
  AuthenticatedSettingsPrivacyRouteImport.update({
    id: '/settings/privacy',
    path: '/settings/privacy',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminNotificationsRoute =
  AuthenticatedAdminNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminMapRoute = AuthenticatedAdminMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminLibraryRoute =
  AuthenticatedAdminLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminInvitesRoute =
  AuthenticatedAdminInvitesRouteImport.update({
    id: '/invites',
    path: '/invites',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminFamilyRoute =
  AuthenticatedAdminFamilyRouteImport.update({
    id: '/family',
    path: '/family',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminExportRoute =
  AuthenticatedAdminExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAiRoute = AuthenticatedAdminAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminTravelersUserIdRoute =
  AuthenticatedAdminTravelersUserIdRouteImport.update({
    id: '/travelers/$userId',
    path: '/travelers/$userId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account-deletion': typeof AccountDeletionRoute
  '/login': typeof LoginRoute
  '/offline-control': typeof OfflineControlRoute
  '/privacy': typeof PrivacyRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/face-id-intro': typeof AuthenticatedFaceIdIntroRoute
  '/inbox': typeof AuthenticatedInboxRoute
  '/itinerary': typeof AuthenticatedItineraryRoute
  '/join': typeof AuthenticatedJoinRoute
  '/library': typeof AuthenticatedLibraryRoute
  '/my-uploads': typeof AuthenticatedMyUploadsRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/permissions': typeof AuthenticatedPermissionsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/queue': typeof AuthenticatedQueueRoute
  '/tracking': typeof AuthenticatedTrackingRoute
  '/trip': typeof AuthenticatedTripRoute
  '/upload': typeof AuthenticatedUploadRoute
  '/upload-mode': typeof AuthenticatedUploadModeRoute
  '/follow/$token': typeof FollowTokenRoute
  '/admin/ai': typeof AuthenticatedAdminAiRoute
  '/admin/export': typeof AuthenticatedAdminExportRoute
  '/admin/family': typeof AuthenticatedAdminFamilyRoute
  '/admin/invites': typeof AuthenticatedAdminInvitesRoute
  '/admin/library': typeof AuthenticatedAdminLibraryRoute
  '/admin/map': typeof AuthenticatedAdminMapRoute
  '/admin/notifications': typeof AuthenticatedAdminNotificationsRoute
  '/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/admin/travelers/$userId': typeof AuthenticatedAdminTravelersUserIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account-deletion': typeof AccountDeletionRoute
  '/login': typeof LoginRoute
  '/offline-control': typeof OfflineControlRoute
  '/privacy': typeof PrivacyRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/face-id-intro': typeof AuthenticatedFaceIdIntroRoute
  '/inbox': typeof AuthenticatedInboxRoute
  '/itinerary': typeof AuthenticatedItineraryRoute
  '/join': typeof AuthenticatedJoinRoute
  '/library': typeof AuthenticatedLibraryRoute
  '/my-uploads': typeof AuthenticatedMyUploadsRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/permissions': typeof AuthenticatedPermissionsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/queue': typeof AuthenticatedQueueRoute
  '/tracking': typeof AuthenticatedTrackingRoute
  '/trip': typeof AuthenticatedTripRoute
  '/upload': typeof AuthenticatedUploadRoute
  '/upload-mode': typeof AuthenticatedUploadModeRoute
  '/follow/$token': typeof FollowTokenRoute
  '/admin/ai': typeof AuthenticatedAdminAiRoute
  '/admin/export': typeof AuthenticatedAdminExportRoute
  '/admin/family': typeof AuthenticatedAdminFamilyRoute
  '/admin/invites': typeof AuthenticatedAdminInvitesRoute
  '/admin/library': typeof AuthenticatedAdminLibraryRoute
  '/admin/map': typeof AuthenticatedAdminMapRoute
  '/admin/notifications': typeof AuthenticatedAdminNotificationsRoute
  '/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/admin/travelers/$userId': typeof AuthenticatedAdminTravelersUserIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/account-deletion': typeof AccountDeletionRoute
  '/login': typeof LoginRoute
  '/offline-control': typeof OfflineControlRoute
  '/privacy': typeof PrivacyRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/face-id-intro': typeof AuthenticatedFaceIdIntroRoute
  '/_authenticated/inbox': typeof AuthenticatedInboxRoute
  '/_authenticated/itinerary': typeof AuthenticatedItineraryRoute
  '/_authenticated/join': typeof AuthenticatedJoinRoute
  '/_authenticated/library': typeof AuthenticatedLibraryRoute
  '/_authenticated/my-uploads': typeof AuthenticatedMyUploadsRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/permissions': typeof AuthenticatedPermissionsRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/queue': typeof AuthenticatedQueueRoute
  '/_authenticated/tracking': typeof AuthenticatedTrackingRoute
  '/_authenticated/trip': typeof AuthenticatedTripRoute
  '/_authenticated/upload': typeof AuthenticatedUploadRoute
  '/_authenticated/upload-mode': typeof AuthenticatedUploadModeRoute
  '/follow/$token': typeof FollowTokenRoute
  '/_authenticated/admin/ai': typeof AuthenticatedAdminAiRoute
  '/_authenticated/admin/export': typeof AuthenticatedAdminExportRoute
  '/_authenticated/admin/family': typeof AuthenticatedAdminFamilyRoute
  '/_authenticated/admin/invites': typeof AuthenticatedAdminInvitesRoute
  '/_authenticated/admin/library': typeof AuthenticatedAdminLibraryRoute
  '/_authenticated/admin/map': typeof AuthenticatedAdminMapRoute
  '/_authenticated/admin/notifications': typeof AuthenticatedAdminNotificationsRoute
  '/_authenticated/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/admin/travelers/$userId': typeof AuthenticatedAdminTravelersUserIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account-deletion'
    | '/login'
    | '/offline-control'
    | '/privacy'
    | '/support'
    | '/terms'
    | '/admin'
    | '/face-id-intro'
    | '/inbox'
    | '/itinerary'
    | '/join'
    | '/library'
    | '/my-uploads'
    | '/notifications'
    | '/permissions'
    | '/profile'
    | '/queue'
    | '/tracking'
    | '/trip'
    | '/upload'
    | '/upload-mode'
    | '/follow/$token'
    | '/admin/ai'
    | '/admin/export'
    | '/admin/family'
    | '/admin/invites'
    | '/admin/library'
    | '/admin/map'
    | '/admin/notifications'
    | '/settings/privacy'
    | '/admin/'
    | '/admin/travelers/$userId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-deletion'
    | '/login'
    | '/offline-control'
    | '/privacy'
    | '/support'
    | '/terms'
    | '/face-id-intro'
    | '/inbox'
    | '/itinerary'
    | '/join'
    | '/library'
    | '/my-uploads'
    | '/notifications'
    | '/permissions'
    | '/profile'
    | '/queue'
    | '/tracking'
    | '/trip'
    | '/upload'
    | '/upload-mode'
    | '/follow/$token'
    | '/admin/ai'
    | '/admin/export'
    | '/admin/family'
    | '/admin/invites'
    | '/admin/library'
    | '/admin/map'
    | '/admin/notifications'
    | '/settings/privacy'
    | '/admin'
    | '/admin/travelers/$userId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/account-deletion'
    | '/login'
    | '/offline-control'
    | '/privacy'
    | '/support'
    | '/terms'
    | '/_authenticated/admin'
    | '/_authenticated/face-id-intro'
    | '/_authenticated/inbox'
    | '/_authenticated/itinerary'
    | '/_authenticated/join'
    | '/_authenticated/library'
    | '/_authenticated/my-uploads'
    | '/_authenticated/notifications'
    | '/_authenticated/permissions'
    | '/_authenticated/profile'
    | '/_authenticated/queue'
    | '/_authenticated/tracking'
    | '/_authenticated/trip'
    | '/_authenticated/upload'
    | '/_authenticated/upload-mode'
    | '/follow/$token'
    | '/_authenticated/admin/ai'
    | '/_authenticated/admin/export'
    | '/_authenticated/admin/family'
    | '/_authenticated/admin/invites'
    | '/_authenticated/admin/library'
    | '/_authenticated/admin/map'
    | '/_authenticated/admin/notifications'
    | '/_authenticated/settings/privacy'
    | '/_authenticated/admin/'
    | '/_authenticated/admin/travelers/$userId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AccountDeletionRoute: typeof AccountDeletionRoute
  LoginRoute: typeof LoginRoute
  OfflineControlRoute: typeof OfflineControlRoute
  PrivacyRoute: typeof PrivacyRoute
  SupportRoute: typeof SupportRoute
  TermsRoute: typeof TermsRoute
  FollowTokenRoute: typeof FollowTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offline-control': {
      id: '/offline-control'
      path: '/offline-control'
      fullPath: '/offline-control'
      preLoaderRoute: typeof OfflineControlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-deletion': {
      id: '/account-deletion'
      path: '/account-deletion'
      fullPath: '/account-deletion'
      preLoaderRoute: typeof AccountDeletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/follow/$token': {
      id: '/follow/$token'
      path: '/follow/$token'
      fullPath: '/follow/$token'
      preLoaderRoute: typeof FollowTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/upload-mode': {
      id: '/_authenticated/upload-mode'
      path: '/upload-mode'
      fullPath: '/upload-mode'
      preLoaderRoute: typeof AuthenticatedUploadModeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/upload': {
      id: '/_authenticated/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof AuthenticatedUploadRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/trip': {
      id: '/_authenticated/trip'
      path: '/trip'
      fullPath: '/trip'
      preLoaderRoute: typeof AuthenticatedTripRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tracking': {
      id: '/_authenticated/tracking'
      path: '/tracking'
      fullPath: '/tracking'
      preLoaderRoute: typeof AuthenticatedTrackingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/queue': {
      id: '/_authenticated/queue'
      path: '/queue'
      fullPath: '/queue'
      preLoaderRoute: typeof AuthenticatedQueueRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/permissions': {
      id: '/_authenticated/permissions'
      path: '/permissions'
      fullPath: '/permissions'
      preLoaderRoute: typeof AuthenticatedPermissionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-uploads': {
      id: '/_authenticated/my-uploads'
      path: '/my-uploads'
      fullPath: '/my-uploads'
      preLoaderRoute: typeof AuthenticatedMyUploadsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/library': {
      id: '/_authenticated/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof AuthenticatedLibraryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/join': {
      id: '/_authenticated/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof AuthenticatedJoinRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/itinerary': {
      id: '/_authenticated/itinerary'
      path: '/itinerary'
      fullPath: '/itinerary'
      preLoaderRoute: typeof AuthenticatedItineraryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inbox': {
      id: '/_authenticated/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthenticatedInboxRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/face-id-intro': {
      id: '/_authenticated/face-id-intro'
      path: '/face-id-intro'
      fullPath: '/face-id-intro'
      preLoaderRoute: typeof AuthenticatedFaceIdIntroRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/settings/privacy': {
      id: '/_authenticated/settings/privacy'
      path: '/settings/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof AuthenticatedSettingsPrivacyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/notifications': {
      id: '/_authenticated/admin/notifications'
      path: '/notifications'
      fullPath: '/admin/notifications'
      preLoaderRoute: typeof AuthenticatedAdminNotificationsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/map': {
      id: '/_authenticated/admin/map'
      path: '/map'
      fullPath: '/admin/map'
      preLoaderRoute: typeof AuthenticatedAdminMapRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/library': {
      id: '/_authenticated/admin/library'
      path: '/library'
      fullPath: '/admin/library'
      preLoaderRoute: typeof AuthenticatedAdminLibraryRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/invites': {
      id: '/_authenticated/admin/invites'
      path: '/invites'
      fullPath: '/admin/invites'
      preLoaderRoute: typeof AuthenticatedAdminInvitesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/family': {
      id: '/_authenticated/admin/family'
      path: '/family'
      fullPath: '/admin/family'
      preLoaderRoute: typeof AuthenticatedAdminFamilyRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/export': {
      id: '/_authenticated/admin/export'
      path: '/export'
      fullPath: '/admin/export'
      preLoaderRoute: typeof AuthenticatedAdminExportRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/ai': {
      id: '/_authenticated/admin/ai'
      path: '/ai'
      fullPath: '/admin/ai'
      preLoaderRoute: typeof AuthenticatedAdminAiRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/travelers/$userId': {
      id: '/_authenticated/admin/travelers/$userId'
      path: '/travelers/$userId'
      fullPath: '/admin/travelers/$userId'
      preLoaderRoute: typeof AuthenticatedAdminTravelersUserIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAiRoute: typeof AuthenticatedAdminAiRoute
  AuthenticatedAdminExportRoute: typeof AuthenticatedAdminExportRoute
  AuthenticatedAdminFamilyRoute: typeof AuthenticatedAdminFamilyRoute
  AuthenticatedAdminInvitesRoute: typeof AuthenticatedAdminInvitesRoute
  AuthenticatedAdminLibraryRoute: typeof AuthenticatedAdminLibraryRoute
  AuthenticatedAdminMapRoute: typeof AuthenticatedAdminMapRoute
  AuthenticatedAdminNotificationsRoute: typeof AuthenticatedAdminNotificationsRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminTravelersUserIdRoute: typeof AuthenticatedAdminTravelersUserIdRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAiRoute: AuthenticatedAdminAiRoute,
  AuthenticatedAdminExportRoute: AuthenticatedAdminExportRoute,
  AuthenticatedAdminFamilyRoute: AuthenticatedAdminFamilyRoute,
  AuthenticatedAdminInvitesRoute: AuthenticatedAdminInvitesRoute,
  AuthenticatedAdminLibraryRoute: AuthenticatedAdminLibraryRoute,
  AuthenticatedAdminMapRoute: AuthenticatedAdminMapRoute,
  AuthenticatedAdminNotificationsRoute: AuthenticatedAdminNotificationsRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAdminTravelersUserIdRoute:
    AuthenticatedAdminTravelersUserIdRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedFaceIdIntroRoute: typeof AuthenticatedFaceIdIntroRoute
  AuthenticatedInboxRoute: typeof AuthenticatedInboxRoute
  AuthenticatedItineraryRoute: typeof AuthenticatedItineraryRoute
  AuthenticatedJoinRoute: typeof AuthenticatedJoinRoute
  AuthenticatedLibraryRoute: typeof AuthenticatedLibraryRoute
  AuthenticatedMyUploadsRoute: typeof AuthenticatedMyUploadsRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedPermissionsRoute: typeof AuthenticatedPermissionsRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedQueueRoute: typeof AuthenticatedQueueRoute
  AuthenticatedTrackingRoute: typeof AuthenticatedTrackingRoute
  AuthenticatedTripRoute: typeof AuthenticatedTripRoute
  AuthenticatedUploadRoute: typeof AuthenticatedUploadRoute
  AuthenticatedUploadModeRoute: typeof AuthenticatedUploadModeRoute
  AuthenticatedSettingsPrivacyRoute: typeof AuthenticatedSettingsPrivacyRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedFaceIdIntroRoute: AuthenticatedFaceIdIntroRoute,
  AuthenticatedInboxRoute: AuthenticatedInboxRoute,
  AuthenticatedItineraryRoute: AuthenticatedItineraryRoute,
  AuthenticatedJoinRoute: AuthenticatedJoinRoute,
  AuthenticatedLibraryRoute: AuthenticatedLibraryRoute,
  AuthenticatedMyUploadsRoute: AuthenticatedMyUploadsRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedPermissionsRoute: AuthenticatedPermissionsRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedQueueRoute: AuthenticatedQueueRoute,
  AuthenticatedTrackingRoute: AuthenticatedTrackingRoute,
  AuthenticatedTripRoute: AuthenticatedTripRoute,
  AuthenticatedUploadRoute: AuthenticatedUploadRoute,
  AuthenticatedUploadModeRoute: AuthenticatedUploadModeRoute,
  AuthenticatedSettingsPrivacyRoute: AuthenticatedSettingsPrivacyRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AccountDeletionRoute: AccountDeletionRoute,
  LoginRoute: LoginRoute,
  OfflineControlRoute: OfflineControlRoute,
  PrivacyRoute: PrivacyRoute,
  SupportRoute: SupportRoute,
  TermsRoute: TermsRoute,
  FollowTokenRoute: FollowTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
